import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { ConfigProvider } from './context/ConfigContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { setWaiting } from './utils/swUpdate';
import { resetPrerenderedHead } from './utils/prerenderedHead';

// A pre-rendered page's head belongs to that page; see utils/prerenderedHead.js.
resetPrerenderedHead();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ConfigProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ConfigProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// Precaches the app shell so the app opens without a connection and serves
// public/offline.html instead of the browser's network-error page. Production
// builds only - see src/service-worker.js (audit B5). A new version found
// after a deploy is offered by components/UpdateBanner.js.
serviceWorkerRegistration.register({ onUpdate: setWaiting });
